import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { DialogConfig } from '@rd/popup/dialog-config';
import { DialogRef } from '@rd/popup/dialog-ref';
import { ButtonModule } from '@rd/shared-legacy/components/button/button.module';
import { IconModule } from '@rd/shared-legacy/components/icon/icon.module';
import { RdContainerModule } from '@rd/shared/container/container.module';

@Component({
  imports: [CommonModule, RdContainerModule, IconModule, ButtonModule],
  selector: 'rd-impersonation-redeem-confirm-dialog',
  template: `
    <rd-container class="p-6 text-[#141414] md:p-12">
      <div class="mb-4 flex items-center gap-4">
        <div class="h-6 w-6 flex-shrink-0">
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 24 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g id="warning">
              <path
                id="Shape"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M23.5013 17.0528L15.0233 1.69586C13.6612 -0.563786 10.3407 -0.566788 8.9767 1.69586L0.499073 17.0528C-0.893396 19.3618 0.792463 22.2857 3.52167 22.2857H20.4781C23.205 22.2857 24.8938 19.3642 23.5013 17.0528ZM12 19.5143C11.2248 19.5143 10.5937 18.8925 10.5937 18.1286C10.5937 17.3648 11.2248 16.7429 12 16.7429C12.7752 16.7429 13.4063 17.3648 13.4063 18.1286C13.4063 18.8925 12.7752 19.5143 12 19.5143ZM12 15.3573C12.7752 15.3573 13.4063 14.7354 13.4063 13.9716V7.04311C13.4063 6.27922 12.7752 5.65741 12 5.65741C11.2248 5.65741 10.5937 6.27922 10.5937 7.04311V13.9716C10.5937 14.7354 11.2248 15.3573 12 15.3573Z"
                fill="#FFA435" />
            </g>
          </svg>
        </div>
        <h5 class="m-0 text-xl font-bold leading-8">Warning</h5>
      </div>
      <div class="mb-12">
        <p class="m-0">You are about to make an impersonated redemption as:</p>
        <p class="m-0 font-bold">{{ userName }}</p>
      </div>
      <div class="flex justify-end gap-4">
        <rd-shared-button
          buttonTheme="secondary"
          [buttonContent]="cancelButtonContent"
          (clickFn)="closeDialogWithConfirm(false)">
          <ng-template #cancelButtonContent
            ><span class="p-4">Cancel</span></ng-template
          >
        </rd-shared-button>
        <rd-shared-button
          buttonTheme="primary"
          [buttonContent]="confirmButtonContent"
          (clickFn)="closeDialogWithConfirm(true)">
          ><ng-template #confirmButtonContent
            ><span class="p-4">Confirm</span></ng-template
          ></rd-shared-button
        >
      </div>
    </rd-container>
  `,
})
export class ImpersonationRedeemConfirmDialogComponent {
  private dialogRef = inject(DialogRef);
  private config =
    inject<DialogConfig<{ userName: string; confirmAction: () => void }>>(
      DialogConfig,
    );

  get userName() {
    return this.config.data?.userName ?? '';
  }

  get confirmAction() {
    return this.config.data?.confirmAction ?? (() => {});
  }

  closeDialogWithConfirm(isConfirmed: boolean) {
    if (isConfirmed) {
      this.confirmAction();
    }

    this.dialogRef.close({
      closeOnSubmit: isConfirmed,
    });
  }
}
